// Local storage utilities for CV data
const STORAGE_KEY = 'gradpath_cv_data_v3';

// Default CV data
export const defaultCVData = {
    personal: {
        name: 'Thabo Nkosi',
        title: 'Software Developer',
        email: 'thabo.nkosi@example.com',
        phone: '+27 12 345 6789',
        location: 'Johannesburg, South Africa',
        linkedin: 'linkedin.com/in/thabonkosi'
    },
    summary: 'Recent Computer Science graduate with distinction from University of Cape Town. Passionate about software development and creating innovative solutions. Strong problem-solving skills and experience in full-stack development.',
    skills: 'JavaScript, Python, React, Node.js, SQL, Git, Agile Methodologies',
    certifications: 'AWS Certified Cloud Practitioner\nGoogle IT Support Professional',
    languages: 'English, Zulu',
    education: [
        {
            id: Date.now(),
            degree: 'Bachelor of Science in Computer Science',
            institution: 'University of Cape Town',
            year: '2020-2024',
            grade: 'First Class Honours'
        },
        {
            id: Date.now() + 1,
            degree: 'National Senior Certificate',
            institution: 'Johannesburg High School',
            year: '2014-2019',
            grade: 'Distinction'
        }
    ],
    experience: [
        {
            id: Date.now() + 2,
            title: 'Software Development Intern',
            company: 'Tech Innovations SA',
            years: '2023-2024',
            responsibilities: 'Developed and maintained web applications using React and Node.js.\nCollaborated with senior developers to implement new features.\nParticipated in code reviews and agile ceremonies.'
        },
        {
            id: Date.now() + 3,
            title: 'IT Support Assistant',
            company: 'University IT Department',
            years: '2022-2023',
            responsibilities: 'Provided technical support to students and staff.\nAssisted with network troubleshooting and software installation.\nManaged help desk tickets and resolved issues efficiently.'
        }
    ]
};

// Save CV data to localStorage
export const saveCVData = (data) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        return true;
    } catch (error) {
        console.error('Error saving CV data:', error);
        return false;
    }
};

// Load CV data from localStorage
export const loadCVData = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
            return JSON.parse(saved);
        }
        return defaultCVData;
    } catch (error) {
        console.error('Error loading CV data:', error);
        return defaultCVData;
    }
};

// Clear CV data
export const clearCVData = () => {
    localStorage.removeItem(STORAGE_KEY);
};